import { Typography } from '@mui/material';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';

import {
  AccordionTitle,
  AccordionTitleWrapper,
} from '../ComponentAccordion.styled';

export const ComponentAccordionTitle = (props: {
  title: string | undefined;
  subTitle?: string;
}) => {
  const { title, subTitle } = props;

  return (
    <AccordionTitleWrapper>
      <CustomTooltip
        width={500}
        placement="right"
        title={title}
        overflowLineNumber={1}>
        <AccordionTitle variant="body1">{title}</AccordionTitle>
      </CustomTooltip>

      {subTitle && <Typography color="textSecondary">{subTitle}</Typography>}
    </AccordionTitleWrapper>
  );
};
